<template>
  <modal-campaign-targeting-rule @save="save" @close="close">
    <div class="d-flex align-items-center">
      <span class="mr-2 flex-shrink-0">CSS selector</span>
      <input class="form-control form-control-sm" v-model="value" />
    </div>
  </modal-campaign-targeting-rule>
</template>

<script>
import ModalCampaignTargetingRule from "@/components/modals/ModalCampaignTargetingRule"
import targetingRuleNames from "@/components/campaign-targeting-rules/targetingRuleNames"
import targetingRuleModalMixin from "@/components/campaign-targeting-rules/modals/targeting-rule-modal-mixin"

const mixin = targetingRuleModalMixin("when", targetingRuleNames.whenRules.clickTo)

export default {
  name: "ClickToModal",
  components: { ModalCampaignTargetingRule },
  mixins: [mixin]
}
</script>
